// EditButton.js
import React from "react";
import { IconButton } from "@mui/material";
import { Edit } from "@mui/icons-material";

const actionButtonStyle = {
  backgroundColor: "background.paper",
  color: "text.primary",
  width: "50px",
  height: "40px",
  borderRadius: "50%",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  border: "1px solid",
  borderColor: "divider",
  "&:hover": {
    backgroundColor: "background.hover",
  },
};

export default function EditButton({ onEditClick }) {
  return (
    <IconButton
      sx={actionButtonStyle}
      onClick={onEditClick}
      aria-label="Edit article"
    >
      <Edit
        sx={{
          color: "primary.main", 
          transition: "color 0.3s ease",
        }}
      />
    </IconButton>
  );
}
